import LoggerService,{formatTrace,formatInfo} from '../../LoggerService';
import {_checkTokens,_checkErrors,_tryOrRefresh,I_COMMON_GET_ALL_PARAMS} from './_base';

import {
  I_PLANIFICATION_TOTALS,
  I_PLANIFICATION_BY_COLLABORATORS,
  I_PLANIFICATION_BY_CUSTOMERS,
  I_PLANIFICATION_BY_ACTIVITYTYPES,
  I_PLANIFICATION_BY_SKILLS,
  I_PLANIFICATION_BY_FUNCTIONS,
} from '../interfaces/I_PLANIFICATION';
import {
  getPlanificationTotalsResponse,
  getPlanificationByCollaboratorsResponse,
  getPlanificationByCustomersResponse,
  getPlanificationByActivityTypesResponse,
  getPlanificationBySkillsResponse,
  getPlanificationByFunctionsResponse,
  getPlanificationByOrganisationsResponse,
} from '../ApiEndpoints';

// ---------------------------------
// --- PLANIFICATION
// ---------------------------------

const logger = LoggerService.getInstance();

interface I_GET_PARAMS extends I_COMMON_GET_ALL_PARAMS {
  from_date: string;  // format yyyy-mm-dd
  to_date: string;
  activity_types: string;
  directions: string;
  hubs: string;
  skills: string;
  functions: string;
  collaborators: string;
  of_number: string;
  audited_customers: string;
  referentials: string;
  referential_types: string;
  postpone?: string;
}
/**
 * Récupère les totaux
 * @param obj
 * @returns
 */
const getTotals = async ({
  accessToken,refreshToken,
  dispatch,state,
  from_date,
  to_date,
  activity_types,
  directions,
  hubs,
  skills,
  functions,
  collaborators,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  postpone,
}:I_GET_PARAMS):Promise<I_PLANIFICATION_TOTALS> => {
  logger.debug('ApiServices - getPlanificationTotals - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getPlanificationTotalsResponse({
        accessToken:usedAccessToken,
        from_date,
        to_date,
        activity_types,
        directions,
        hubs,
        skills,
        functions,
        collaborators,
        audited_customers,
        referentials,
        referential_types,
        of_number,
        postpone,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getPlanificationTotals - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_PLANIFICATION_TOTALS = await response.json();
  logger.debug('ApiServices - getPlanificationTotals - ok, returned body',body);
  return body;
};

/**
 * Récupère les
 * @param obj
 * @returns
 */
const getByCollaborators = async ({
  accessToken,refreshToken,
  dispatch,state,
  from_date,
  to_date,
  activity_types,
  directions,
  hubs,
  skills,
  functions,
  collaborators,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  postpone,
}:I_GET_PARAMS):Promise<I_PLANIFICATION_BY_COLLABORATORS> => {
  logger.debug('ApiServices - getPlanificationByCollaborators - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getPlanificationByCollaboratorsResponse({
        accessToken:usedAccessToken,
        from_date,
        to_date,
        activity_types,
        directions,
        hubs,
        skills,
        functions,
        collaborators,
        audited_customers,
        referentials,
        referential_types,
        of_number,
        postpone,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getPlanificationByCollaborators - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_PLANIFICATION_BY_COLLABORATORS = await response.json();
  logger.debug('ApiServices - getPlanificationByCollaborators - ok, returned body',body);
  return body;
};

/**
 * Récupère les
 * @param obj
 * @returns
 */
const getByCustomers = async ({
  accessToken,refreshToken,
  dispatch,state,
  from_date,
  to_date,
  activity_types,
  directions,
  hubs,
  skills,
  functions,
  collaborators,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  postpone,
}:I_GET_PARAMS):Promise<I_PLANIFICATION_BY_CUSTOMERS> => {
  logger.debug('ApiServices - getPlanificationByCustomers - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getPlanificationByCustomersResponse({
        accessToken:usedAccessToken,
        from_date,
        to_date,
        activity_types,
        directions,
        hubs,
        skills,
        functions,
        collaborators,
        audited_customers,
        referentials,
        referential_types,
        of_number,
        postpone,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getPlanificationByCustomers - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_PLANIFICATION_BY_CUSTOMERS = await response.json();
  logger.debug('ApiServices - getPlanificationByCustomers - ok, returned body',body);
  return body;
};


/**
 * Récupère les
 * @param obj
 * @returns
 */
const getByActivityTypes = async ({
  accessToken,refreshToken,
  dispatch,state,
  from_date,
  to_date,
  activity_types,
  directions,
  hubs,
  skills,
  functions,
  collaborators,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  postpone,
}:I_GET_PARAMS):Promise<I_PLANIFICATION_BY_ACTIVITYTYPES> => {
  logger.debug('ApiServices - getPlanificationByActivityTypes - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getPlanificationByActivityTypesResponse({
        accessToken:usedAccessToken,
        from_date,
        to_date,
        activity_types,
        directions,
        hubs,
        skills,
        functions,
        collaborators,
        audited_customers,
        referentials,
        referential_types,
        of_number,
        postpone,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getPlanificationByActivityTypes - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_PLANIFICATION_BY_ACTIVITYTYPES = await response.json();
  logger.debug('ApiServices - getPlanificationByActivityTypes - ok, returned body',body);
  return body;
};


/**
 * Récupère les
 * @param obj
 * @returns
 */
const getBySkills = async ({
  accessToken,refreshToken,
  dispatch,state,
  from_date,
  to_date,
  activity_types,
  directions,
  hubs,
  skills,
  functions,
  collaborators,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  postpone,
}:I_GET_PARAMS):Promise<I_PLANIFICATION_BY_SKILLS> => {
  logger.debug('ApiServices - getPlanificationBySkills - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getPlanificationBySkillsResponse({
        accessToken:usedAccessToken,
        from_date,
        to_date,
        activity_types,
        directions,
        hubs,
        skills,
        functions,
        collaborators,
        audited_customers,
        referentials,
        referential_types,
        of_number,
        postpone,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getPlanificationBySkills - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_PLANIFICATION_BY_SKILLS = await response.json();
  logger.debug('ApiServices - getPlanificationBySkills - ok, returned body',body);
  return body;
};

/**
 * Récupère les
 * @param obj
 * @returns
 */
const getByFunctions = async ({
  accessToken,refreshToken,
  dispatch,state,
  from_date,
  to_date,
  activity_types,
  directions,
  hubs,
  skills,
  functions,
  collaborators,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  postpone,
}:I_GET_PARAMS):Promise<I_PLANIFICATION_BY_FUNCTIONS> => {
  logger.debug('ApiServices - getPlanificationByFunctions - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getPlanificationByFunctionsResponse({
        accessToken:usedAccessToken,
        from_date,
        to_date,
        activity_types,
        directions,
        hubs,
        skills,
        functions,
        collaborators,
        audited_customers,
        referentials,
        referential_types,
        of_number,
        postpone,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getPlanificationByFunctions - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_PLANIFICATION_BY_FUNCTIONS = await response.json();
  logger.debug('ApiServices - getPlanificationByFunctions - ok, returned body',body);
  return body;
};


/**
 * Récupère les
 * @param obj
 * @returns
 */
const getByOrganisations = async ({
  accessToken,refreshToken,
  dispatch,state,
  from_date,
  to_date,
  activity_types,
  directions,
  hubs,
  skills,
  functions,
  collaborators,
  audited_customers,
  referentials,
  referential_types,
  of_number,
  postpone,
}:I_GET_PARAMS):Promise<I_PLANIFICATION_BY_FUNCTIONS> => {
  logger.debug('ApiServices - getPlanificationByOrganisations - ...');
  // pre-verification qu'on a bien des token, sinon sert a rien de faire la requete
  await _checkTokens(accessToken,refreshToken);
  // requete le endpoint
  const response = await _tryOrRefresh({
    request: (usedAccessToken:string) => {
      return getPlanificationByOrganisationsResponse({
        accessToken:usedAccessToken,
        from_date,
        to_date,
        activity_types,
        directions,
        hubs,
        skills,
        functions,
        collaborators,
        audited_customers,
        referentials,
        referential_types,
        of_number,
        postpone,
      });
    },
    accessToken: accessToken || '', // normalement c'est non vide car on a fait un checkTokens
    refreshToken: refreshToken || '', // normalement c'est non vide car on a fait un checkTokens
    dispatch,state
  });
  logger.trace(...formatTrace('ApiServices - getPlanificationByOrganisations - returned response',response));
  // verifie que la reponse est ok, sinon throw error
  await _checkErrors(response);
  // extrait les données
  const body:I_PLANIFICATION_BY_FUNCTIONS = await response.json();
  logger.debug('ApiServices - getPlanificationByOrganisations - ok, returned body',body);
  return body;
};

const planificationServices = {
  getTotals,
  getByCollaborators,
  getByCustomers,
  getByActivityTypes,
  getBySkills,
  getByFunctions,
  getByOrganisations,
};

export default planificationServices;
